import React, { PropsWithChildren, useId } from "react";
import styles from "./index.module.scss";
import { useDropdownMenu } from "hooks/useDropdownMenu";
import { DropDirection } from "components/inputs/context-menu";

export interface ContextMenuItem {
    key: string;
    text: string;
    onClick: (...args: any) => any;
}

export interface ContextMenuProps extends PropsWithChildren {
    items: ContextMenuItem[];
    dropDirection?: DropDirection;
}

export const ContextMenuWrapper = ({
    items,
    dropDirection = "down",
    children
}: ContextMenuProps) => {
    const menuId = useId();
    const {
        isOpen,
        activeIndex,
        toggle,
        close,
        containerRef,
        triggerRef,
        itemRefs,
        onTriggerKeyDown,
        onMenuKeyDown
    } = useDropdownMenu(items.length);

    return (
        <div
            ref={containerRef as React.RefObject<HTMLDivElement>}
            className={dropDirection === "up" ? "dropup" : "dropdown"}
        >
            <div
                ref={triggerRef as React.RefObject<HTMLDivElement>}
                aria-haspopup="menu"
                aria-expanded={isOpen}
                aria-controls={menuId}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    toggle();
                }}
                onKeyDown={onTriggerKeyDown}
            >
                {children}
            </div>
            {isOpen && (
                <div
                    id={menuId}
                    role="menu"
                    className="dropdown-menu dropdown-menu-right show"
                    onKeyDown={onMenuKeyDown}
                >
                    {items.map((item, index) => (
                        <a
                            key={item.key}
                            href="#"
                            role="menuitem"
                            tabIndex={activeIndex === index ? 0 : -1}
                            ref={(el) => {
                                itemRefs.current[index] = el;
                            }}
                            className={`dropdown-item ${styles["context-menu-item"]}`}
                            onClick={(e) => {
                                e.preventDefault();
                                item.onClick && item.onClick();
                                close(true);
                            }}
                        >
                            {item.text}
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
};
